import {
    fetchNotificationStatuses,
    fetchViolationStatuses,
    fetchViolationTypes,
} from '@entities/violations/api';
import {ViolationSearchResponse, ViolationsSearchPayload} from '@entities/violations/types';
import api from '@shared/api';

const VIOLATIONS_PATH = 'dda/api/v1';

export const fetchViolations = async (payload: ViolationsSearchPayload) =>
    (await api.post<ViolationSearchResponse>(`${VIOLATIONS_PATH}/violation/search`, payload)).data;

export {fetchNotificationStatuses, fetchViolationStatuses, fetchViolationTypes};
